const featuresPay = {
    featureTitle: '數據驅動 作出業務決策',
    featureDescription:
        '清楚知道邊啲貨品賣得最多、邊啲利潤最高，隨時隨地查閱財務報告。您的業務盡在掌握！',
    featureButton: "高級訂閱",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: '由',
    featureEndingText: '千起',

    features: [
        {
            title: '無限貨品',
            description: '無限量新增您擁有嘅所有貨品，冇上限。'
        },
        {
            title: '無限員工',
            description: '無限量新增員工/管理員到業務，冇上限。'
        },
        {
            title: '無限記錄',
            description: '無限量查看舊存貨記錄嘅變更，冇上限。'
        },
        {
            title: '記錄篩選',
            description: '輕鬆按類型、類別、員工同日期篩選查看記錄。'
        },
        {
            title: '下載 Excel',
            description: '一鍵將存貨記錄歷史匯出到 Microsoft Excel。'
        },
        {
            title: '下載 PDF',
            description: '一鍵將最新貨品同存貨清單匯出成 PDF。'
        }
    ],
    warehousesGuide: [
        {
            desc: '建立多個倉庫，更好管理存貨。'
        },
        {
            desc: '將產品指定分配到特定位置。'
        },
        {
            desc: '監察各個倉庫嘅存貨水平。'
        }
    ],
    addVariantsGuide: [
        { desc: '新增尺寸、顏色或物料等變體。' },
        { desc: '為每個變體設定存貨量。' },
        { desc: '跨倉庫追蹤存貨。' }
    ]
}
export default featuresPay